import type { TTermTag } from '@/types'
import { LOCALES } from '@/common'

export default {
  id: `e2e`,

  name: {
    [LOCALES.EN_US]: `E2E`,
    [LOCALES.EN_GB]: LOCALES.EN_US,
    [LOCALES.DE_DE]: LOCALES.EN_US,
  },
} as const satisfies TTermTag
